const actorsData = [
    {
      id: 1,
      name: 'Mahira Khan',
      bio: 'Award-winning actress known for her role in Humsafar and Raees.',
      avatar: 'https://e0.pxfuel.com/wallpapers/406/230/desktop-wallpaper-mahira-khan-hot-instagram-husband-more.jpg',
      skills: ['Acting', 'Modeling', 'Hosting'],
      portfolio: 'https://www.imdb.com/name/nm3733133/',
      github: 'https://github.com/mahira-khan'
    },
    {
      id: 2,
      name: 'Fawad Khan',
      bio: 'Top Pakistani actor and singer, featured in Bollywood films.',
      avatar: 'https://media5.bollywoodhungama.in/wp-content/uploads/2016/05/473735691.jpg',
      skills: ['Acting', 'Singing', 'Modeling'],
      portfolio: 'https://www.imdb.com/name/nm3468327/',
      github: 'https://github.com/fawad-khan'
    },
    {
      id: 3,
      name: 'Sajal Aly',
      bio: 'Critically acclaimed actress with international projects.',
      avatar: 'https://img-mm.manoramaonline.com/content/dam/mm/mo/web-stories/movies/images/2025/3/11/sajal-ali-3.jpg',
      skills: ['Acting', 'Dancing'],
      portfolio: 'https://www.imdb.com/name/nm5301385/',
      github: 'https://github.com/sajal-aly'
    },
    {
      id: 4,
      name: 'Ahad Raza Mir',
      bio: 'Actor known for Ehd-e-Wafa and Netflix’s Resident Evil series.',
      avatar: 'https://ntvb.tmsimg.com/assets/assets/1180726_v9_aa.jpg',
      skills: ['Acting', 'Singing'],
      portfolio: 'https://www.imdb.com/name/nm8571086/',
      github: 'https://github.com/ahad-mir'
    },
    {
      id: 5,
      name: 'Mehwish Hayat',
      bio: 'Actress and singer, Tamgha-e-Imtiaz recipient.',
      avatar: 'https://media.themoviedb.org/t/p/w500/uIIocsDjy4HKRJnSgmK6ENFP33G.jpg',
      skills: ['Acting', 'Singing'],
      portfolio: 'https://www.imdb.com/name/nm3804502/',
      github: 'https://github.com/mehwish-hayat'
    },
    {
      id: 6,
      name: 'Humayun Saeed',
      bio: 'Veteran actor and film producer with major cinema hits.',
      avatar: 'https://jang.com.pk/assets/uploads/updates/2024-10-02/21979_3862210_Humayun-Saeed_updates.jpg',
      skills: ['Acting', 'Production'],
      portfolio: 'https://www.imdb.com/name/nm1560944/',
      github: 'https://github.com/humayun-saeed'
    }
  ];
  
  export default actorsData; 
  
